@if (years) {
  <div class="mb-2 flex gap-3 align-items-center">
    @if (label) {
      <label class="flex gap-2 align-items-center"
        ><i class="fas fa-calendar-days"></i> {{ label }}</label
      >
    }
    <app-check-all
      class="ml-auto"
      [(selection)]="selection"
      [items]="years"
      (selectionChange)="onChange($event)"></app-check-all>
  </div>
  <div class="flex flex-column flex-wrap gap-1 h-10rem">
    @for (year of nonForecastYearsList; track $index) {
      <p-checkbox
        [ngModel]="isInverseSelected(year)"
        [ngModelOptions]="{ standalone: isStandalone }"
        [binary]="true"
        (ngModelChange)="toggleSelection(year, $event)"
        [label]="year + ''"
        [name]="name"
        [value]="year" />
    }
  </div>
  @if (forecastYearsList.length > 0) {
    <div class="forecast-year-heading mt-2 mb-1">Prognosejahre</div>
    <div class="flex flex-column flex-wrap gap-1 h-10rem">
      @for (year of forecastYearsList; track $index) {
        <p-checkbox
          [ngModel]="isInverseSelected(year)"
          [ngModelOptions]="{ standalone: isStandalone }"
          [binary]="true"
          (ngModelChange)="toggleSelection(year, $event)"
          [label]="year + ''"
          [name]="name"
          [value]="year" />
      }
    </div>
  }
}
